import * as React from "react";
import { OverlayContainerViewStyle } from "./overlay-container-view-style";
import { OverlayTextAlignment } from "common/generator/components/image-types";

interface Props {
    topLeft?: React.ReactNode;
    topRight?: React.ReactNode;
    bottomLeft?: React.ReactNode;
    bottomRight?: React.ReactNode;
    center?: React.ReactNode;
    mainCorner?: OverlayTextAlignment;
    className?: string;
}

const OverlayContainerView: React.FunctionComponent<Props> = React.memo((props: Props) => {
    // eslint-disable-next-line prefer-const
    let { topLeft, topRight, bottomLeft, bottomRight, center, mainCorner, className } = props;

    function makeCornerClassName(name: string, isMain: boolean): string {
        return `${name} corner-content${isMain ? " shrink" : ""}`;
    }

    topLeft = topLeft && (
        <div className={makeCornerClassName("top-left-content", mainCorner === "top-left")}>{topLeft}</div>
    );
    topRight = topRight && (
        <div className={makeCornerClassName("top-right-content", mainCorner === "top-right")}>{topRight}</div>
    );
    bottomLeft = bottomLeft && (
        <div className={makeCornerClassName("bottom-left-content", mainCorner === "bottom-left")}>{bottomLeft}</div>
    );
    bottomRight = bottomRight && (
        <div className={makeCornerClassName("bottom-right-content", mainCorner === "bottom-right")}>{bottomRight}</div>
    );

    return (
        <OverlayContainerViewStyle className={className}>
            <div className="tile-corner-container">
                {topLeft}
                {topRight}
            </div>
            <div className="tile-corner-container">
                {bottomLeft}
                {bottomRight}
            </div>
            {center && <div className={makeCornerClassName("center-content", false)}>{center}</div>}
        </OverlayContainerViewStyle>
    );
});

export default OverlayContainerView;
